import { useReducer } from "react";
import { initialState, reducer, } from 'store/snackbarReducer';
import SnackbarContext from 'store/SnackbarContext';

export const SnackbarContextProvider = ({ children }) => {
    const [confirmState, confirmDispatch] = useReducer(reducer, initialState);

    return (
        <SnackbarContext.Provider value={[confirmState, confirmDispatch]}>
            {children}
        </SnackbarContext.Provider>
    )
}